export default {
      id: "tour-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#tour",
      toString: function () {
        return this.url;
      }
    }